import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { TitleService } from './services/hasTitle.service';
import { HeaderComponent } from '@layouts/header/header.component';
import { SidebarComponent } from '@layouts/sidebar/sidebar.component';
import { LoaderComponent } from '@shared/components/loader.component';
import { CommonModule } from '@angular/common';
import { LanguageService } from './services/language.service';
import { LoaderService } from './services/loader.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, LoaderComponent, CommonModule],
  templateUrl: './app.html'
})
export class App implements OnInit {
  protected readonly title = signal('demande');
  isSidebarOpen = false;
  showLayout = true; // Controls visibility of sidebar and header

  private titleService = inject(TitleService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  public loaderService = inject(LoaderService);
  private destroyRef = inject(DestroyRef);

  constructor() {
    const titleIsSet = this.titleService.getHasTitleFromUrl();
    this.titleService.setHasTitle(titleIsSet);
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        const lang = params['lang'];
        if (lang) {
          this.languageService.setLanguage(lang);
        }
      });

    // Listen to route changes to hide/show layout
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        // Hide layout on unauthorized and 404 pages
        this.showLayout = !event.url.includes('/unauthorized') && !event.url.includes('/404');
      });

    // Check initial route
    this.showLayout = !this.router.url.includes('/unauthorized') && !this.router.url.includes('/404');
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }
}
